import { render, staticRenderFns } from "./add-more-candidate-new.vue?vue&type=template&id=2fb0bbb1&scoped=true"
import script from "./add-more-candidate-new.vue?vue&type=script&lang=ts"
export * from "./add-more-candidate-new.vue?vue&type=script&lang=ts"
import style0 from "./add-more-candidate-new.vue?vue&type=style&index=0&id=2fb0bbb1&prod&lang=scss&scoped=true"
import style1 from "./add-more-candidate-new.vue?vue&type=style&index=1&id=2fb0bbb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb0bbb1",
  null
  
)

export default component.exports